export default __webpack_public_path__ + "static/media/good-karma-logo.ff6e5bee.png";